import React from 'react'
// TODO: https://codepen.io/werm/pen/BhtLm
import cn from 'classnames'
import s from './LoadingDots.scss'
import sLay from 'styles/modules/layout.scss'

export default props => (
  <span
    className={cn(sLay['layout-row'], sLay['layout-align-center'], props.className)}
    style={props.style}
  >
    <span className={cn(s.dot, s.dot3, props.sm && s.sm, props.shadow && s.shadow)} />
    <span className={cn(s.dot, s.dot2, props.sm && s.sm, props.shadow && s.shadow)} />
    <span className={cn(s.dot, s.dot1, props.sm && s.sm, props.shadow && s.shadow)} />
  </span>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Loading/LoadingDots/LoadingDots.jsx